var map = {
	"./payex-logo-h.svg": 1916,
	"./payex-logo-neg.png": 2881,
	"./payex-logo-neg.svg": 230,
	"./payex-logo-v.svg": 5946,
	"./payex-logo.png": 2228,
	"./payex-logo.svg": 2819
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8736;